import React from 'react';
import { AlertType, AlertLabel } from '../../types/alerts';

import Badge from '../Badge';
import { BadgeVariant } from '../Badge/types';

type AlertBadgeProps = {
  alertType: AlertType;
  label?: string;
};

const AlertBadge = ({ alertType, label }: AlertBadgeProps): JSX.Element => {
  const variant = {
    [AlertType.INFORMATION]: BadgeVariant.Info,
    [AlertType.WARNING]: BadgeVariant.Warning,
    [AlertType.CLOSURE]: BadgeVariant.Danger
  }[alertType];
  const defaultLabel = {
    [AlertType.INFORMATION]: AlertLabel.INFORMATION,
    [AlertType.WARNING]: AlertLabel.ADVISORY,
    [AlertType.CLOSURE]: AlertLabel.CLOSURE
  }[alertType];

  return <Badge variant={variant} label={label || defaultLabel} />;
};

export default AlertBadge;
